module.exports = __webpack_public_path__ + "69e6c4256e9cb84a999e0b71d7c2a9de.svg";